import { useTranslation } from 'react-i18next';

import { modalState } from '@/state/modal.state';
import type { DropdownOption } from '@/ui/dropdown/dropdown';
import { WithDropdown } from '@/ui/dropdown/dropdown';
import { MenuButton } from '@/ui/menu-button/menu-button';
import type { Template } from '@/api/v4/template.api';
import { useSetAtom } from 'jotai';

export const TemplatesActionsMenu = ({ template }: { template: Template }) => {
  const { t } = useTranslation('settings', {
    keyPrefix: 'manageTemplatesTab',
  });

  const setModalState = useSetAtom(modalState);

  const menu: DropdownOption[] = [
    {
      label: t`deleteTemplate`,
      onClick: () =>
        setModalState({
          state: 'deleteTemplate',
          templateId: template.id,
        }),
    },
  ];

  return (
    <WithDropdown
      items={menu}
      options={{
        placement: 'bottom-start',
        modifiers: [{ name: 'offset', options: { offset: [0, 5.5] } }],
      }}
      data-testid="template-actions-menu"
    >
      <MenuButton />
    </WithDropdown>
  );
};
